
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ButtonRow extends Vue {
  @Prop(String)
  group!: string;

  @Prop({ type: Boolean, default: true })
  valid!: boolean;

  @Emit()
  cancel() {}
}
